import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

export const ncarbSchedulingPathStart = 'Candidate|Scheduling|Scheduling|';
export const ncarbSchedulingSharedProperties: Pick<
	LocDef,
	'shared' | 'htmlAllowed' | 'feature' | 'portal'
> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamSchedulingNcarbAuthorizationDetail,
	portal: 'SP',
};

export type SPCandidateHistorySchedulingNcarbLocNames = 'SPCandidateHistorySchedulingNcarbTabTitle';

export const spCandidateHistorySchedulingNcarbLocs: LocDefs<SPCandidateHistorySchedulingNcarbLocNames> =
	{
		SPCandidateHistorySchedulingNcarbTabTitle: {
			defaultValue: 'Candidate Scheduling | Schedule',
			description: 'Tab title for the canidate scheduling tab.',
			displayPath: `${ncarbSchedulingPathStart}Tab Title`,
			displayType: 'Title',
			...ncarbSchedulingSharedProperties,
		},
	};

export type SPCandidateHistorySchedulingNcarbLocType =
	LocMap<SPCandidateHistorySchedulingNcarbLocNames>;
